export default __webpack_public_path__ + "static/media/mike-cindy-1.6cb00d63.jpeg";